import {
  DAPP_ICON,
  DAPP_NAME,
  SYMBOL_NAME,
  TransactionName,
} from './constants';
import {
  writeTransactionFromWallet,
  readTransactionFromWallet,
} from './extensionMethods/app';
import config from './config';

export const ExecuteSubmitTransaction = async (
  channelName,
  chainCodeName,
  transactionName,
  transactionParams
) => {
  let response;
  let errMsg = '';
  try {
    const dappToken = localStorage.getItem('opensea_dappToken') || '';
    if (!dappToken) throw new Error('Error: no dappToken exists');

    const res = await writeTransactionFromWallet(
      dappToken,
      DAPP_NAME,
      config.DAPP_URL,
      DAPP_ICON,
      channelName,
      chainCodeName,
      transactionName,
      transactionParams
    );
    console.log(
      'response from Write Transaction is:',
      res?.response?.response
      // transactionName,
      // res.transactionId
    );
    response = res?.response?.response;
  } catch (error) {
    console.log(`Error: ${error}`);
    errMsg = 'An error occurred during the transaction.';
  } finally {
    return [response, errMsg];
  }
};

export const ExecuteReadTransaction = async (
  channelName,
  chainCodeName,
  transactionName,
  transactionParams
) => {
  try {
    const dappToken = localStorage.getItem('opensea_dappToken') || '';
    if (!dappToken) throw new Error('Error: no dappToken exists');
    console.log(
      '---------------Before Read Transaction is:',
      dappToken,
      DAPP_NAME,
      config.DAPP_URL,
      DAPP_ICON,
      channelName,
      chainCodeName,
      transactionName,
      transactionParams
    );
    const readTransactionPromise = await readTransactionFromWallet(
      dappToken,
      DAPP_NAME,
      config.DAPP_URL,
      DAPP_ICON,
      channelName,
      chainCodeName,
      transactionName,
      transactionParams
    );
    console.log(
      '----------------response from Read Transaction is:',
      readTransactionPromise,
      transactionName
    );
    return [readTransactionPromise, ''];
  } catch (error) {
    console.log('Error in ExecuteReadTransaction:', error);
    return [null, error.message];
  }
};

export function formattedErrorMessage(rawError) {
  if (!rawError) return 'An unknown error occurred. Please try again.';

  const cleanedError = rawError
    .replace(/chaincode response \d{3},.*?:\s*/, '')
    .replace(/invalid input \d{3}:\s*/, '')
    .trim();

  return cleanedError || 'An unknown error occurred. Please try again.';
}

export default function formatAddress(address) {
  if (!address) return '';
  return (
    address.slice(0, 4) +
    ' ' +
    address.slice(4, 8) +
    ' ' +
    address.slice(8, 12) +
    ' ...... ' +
    address.slice(address.length - 5)
  );
}
